export const DeviceType = {
    MOBILE_REGISTRATION: 'Mobile',
    FIXEDLINE_REGISTRATION: 'Fixed Line'
}